// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"59abc956","453":"ad6eb26e","796":"8eb20619"}[chunkId] + ".chunk.js";
};